import React, {Children, cloneElement, ReactElement} from "react";
import styles from './Quote.module.scss'
import Experiences from "@/Molecules/Experiences/Experiences";



export const Quote = (
  {
    className,
    content,
    author,
    badge,
  }: {
    className?: any,
    content: any,
    author: string,
    badge?: React.ReactNode,
}) => {

  return <section className={`py-10 ${className ?? ''}`}>
    <div className="container">
      <div className={styles.quoteWrapper}>
        {badge && <div className={styles.badge}>{badge}</div>}
        <div className={styles.quote}>
          "{content}"
        </div>
        <div className={styles.author}>{author}</div>
      </div>
    </div>
  </section>

}

export default Quote;
